export default __webpack_public_path__ + "static/color-c60676ded1aea85d64b84140b6389535.mp4";